module.exports = function getResource(label, vars = []) {
    const resources = { standard: 'Standard' };
    return resources[label];
};
